export type AutoplayOptions = {
    turboMode: boolean | null;
    singleWin: number | null;
    winLimit: number | null;
    lossLimit: number | null;
    autoplaySpins: number | null;
};

export type PartialAutoplayOptions = Partial<AutoplayOptions>;

export type AutoplayOptionsOptionsKeys = keyof AutoplayOptions;